const locale = {
    placeholder: 'Оберіть час',
};
export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/uk_UA.tsx